import { render, staticRenderFns } from "./agregarBucket.vue?vue&type=template&id=688c6279&"
import script from "./agregarBucket.vue?vue&type=script&lang=js&"
export * from "./agregarBucket.vue?vue&type=script&lang=js&"
import style0 from "./agregarBucket.vue?vue&type=style&index=0&id=688c6279&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports